import React, { memo, useEffect } from "react"
import { useDispatch } from "react-redux"
import { getActiveProfileTabIndex } from "utils/componentsUtils"
import { useAppSelector } from "appRedux/hooks"
import { updateSelectedTabIndex } from "appRedux/slices/profileTabsSlice"
import useUserProfile from "hooks/useUserProfile"
import ProfilePageTemplate from "components/templates/ProfilePageTemplate"
import ShareProfileModal from "components/templates/ShareProfileModal"

export default memo(function ProfilePage() {
  const selectedTabIndex = useAppSelector((state) => state.profileTabs.selectedTabIndex)
  const currentPageInfo = useAppSelector((state) => state.global.currentPageInfo)

  const { profile, isFetching } = useUserProfile()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!currentPageInfo?.dynamicPathParts?.handle) return
    initializeComponent()
  }, [profile])

  function initializeComponent() {
    if (!profile) return
    const activeTabIndex = getActiveProfileTabIndex(selectedTabIndex[profile.handle], profile)
    dispatch(updateSelectedTabIndex({ handle: profile.handle, index: activeTabIndex as ProfileSelectedTabIndex }))
  }

  return (
    <>
      <ProfilePageTemplate
        userInfo={profile as Profile}
        loading={isFetching}
      />
      <ShareProfileModal/>
    </>
  )
})
